import { MutationTree } from 'vuex';
import { WorldState } from './types';
import { WorldMarker } from '@/interfaces/Marker';
import Vue from 'vue';
import Migrator from '@/classes/migrator';
import { World } from '@/interfaces/world/world';
import { LibraryItem } from '@/interfaces/world/library';

export const mutations: MutationTree<WorldState> = {
  /**
   * Sets the passed fight as the current fight of the user
   * @param state
   * @param currentFight
   */

  addMarker(state, marker: WorldMarker) {
    state.markers.push(marker);
  },

  setPersons(state, persons) {
    state.persons = persons;
  },

  addPerson(state, payload) {
    payload = Migrator.migratePerson(payload);

    const index = state.persons.findIndex((person) => {
      return person.id === payload.id;
    });

    if (!payload.hasOwnProperty('importance')) {
      payload.importance = 1;
    }

    if (index >= 0) {
      Vue.set(state.persons, index, payload);
    } else {
      state.persons.push(payload);
    }
  },

  deletePerson(state, id) {
    const index = state.persons.findIndex((person) => {
      return person.id === id;
    });
    if (index >= 0) {
      state.persons.splice(index, 1);
    }
  },

  addAvailableWorld(state, world: World) {

    const index = state.availableWorlds.findIndex((existingWorld) => {
      return existingWorld.slug === world.slug;
    });

    if (index >= 0) {
      Vue.set(state.availableWorlds, index, world);
    } else {
      state.availableWorlds.push(world);
    }
  },

  setLibraryItem(state, libraryItem: LibraryItem) {

    const index = state.library.findIndex((localItem) => {
      return localItem.id === libraryItem.id;
    });

    if (index >= 0) {
      Vue.set(state.library, index, libraryItem);
    } else {
      state.library.push(libraryItem);
    }
  },
};
